// Money for the Guess the Check game. Amounts are dollars as numbers; comparisons happen in cents so
// $10.10 vs $10.30 around a $10.20 check is a real tie, not a floating-point win.

/** True when x is a usable dollar amount (0 counts: a $0 guess is a guess). */
export function isAmount(x) {
  return typeof x === 'number' && Number.isFinite(x);
}

/** Parse user input into a non-negative amount, or null. Accepts '12', '12.5', '$12.50', ' 12,50 ' (comma as decimal). */
export function parseAmount(input) {
  if (isAmount(input)) return input < 0 ? null : input;
  if (typeof input !== 'string') return null;
  const cleaned = input.replace(/[$\s]/g, '').replace(/,(\d{1,2})$/, '.$1').replace(/,/g, '');
  if (!/^\d*\.?\d*$/.test(cleaned) || cleaned === '' || cleaned === '.') return null;
  const n = Number(cleaned);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

export function cents(x) {
  return Math.round(x * 100);
}

export function fmtMoney(x) {
  return isAmount(x) ? `$${x.toFixed(2)}` : '—';
}

/**
 * Decide the check game. Returns { dougDiff, lesDiff, winner: 'doug' | 'les' | 'tie' } with diffs in dollars (2 dp).
 * A missing guess counts as 0, as in the original game.
 */
export function checkWinner(dougGuess, lesGuess, actual) {
  const a = cents(isAmount(actual) ? actual : 0);
  const d = Math.abs(cents(isAmount(dougGuess) ? dougGuess : 0) - a);
  const l = Math.abs(cents(isAmount(lesGuess) ? lesGuess : 0) - a);
  return { dougDiff: d / 100, lesDiff: l / 100, winner: d < l ? 'doug' : l < d ? 'les' : 'tie' };
}
